// extracted by mini-css-extract-plugin
module.exports =  {"wishlistButton":"GTh3h9","iconContainer":"o4MsmY","heartIcon":"VGRWox","filled":"W8EzRU"};